import Vue from "vue";
import { snippet } from "@js/util";

const getQueryString = name => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2];
  return null;
};

const rid = parseInt(getQueryString("rid"));
const i = parseInt(getQueryString("i"));
const detail = getQueryString("detail");

const vState = Vue.observable({
  i,
  rid,
  detail
});

const vMutations = {
  async submit(id) {
    this.$loading.show("加载验证码");
    const [vErr, vdata] = await this.$to(this.neCaptchaVerify());
    if (vErr) {
      console.log(vErr);
      return false;
    }
    this.$loading.show("正在提交");
    const [err, res] = await this.$to(
      this.$axios.post(
        this.$store.api.vote,
        this.$qs.stringify({
          vdata,
          votes: snippet(`${id}`),
          content: "乐从发布-乐从2019年度好老师评选投票"
        })
      )
    );
    this.$loading.hide();
    if (err) {
      console.log(err);
      return false;
    }
    console.log(res);
    if (res.data.statusCode === "200") {
      this.swal("", res.data.msg);
      return true;
    } else {
      this.swal("", res.data.msg);
      return false;
    }
  },
  sortarr(arr, key) {
    for (let i = 0; i < arr.length - 1; i++) {
      for (let j = 0; j < arr.length - 1 - i; j++) {
        if (parseInt(arr[j][key]) > parseInt(arr[j + 1][key])) {
          var temp = arr[j];
          arr[j] = arr[j + 1];
          arr[j + 1] = temp;
        }
      }
    }
    return arr.reverse();
  }
};

const vApi = {
  list: `http://www.foshannews.net/zt/2020/wx/zmjt/index.json`,
  vote: `./index.php?i=${vState.i}&c=entry&rid=${vState.rid}&do=newvote&m=citygf`,
  voteRank: `./index.php?i=${vState.i}&c=entry&rid=${vState.rid}&do=GetNewVoteData&m=citygf`
};

export { vState, vMutations, vApi };
